import React from 'react';
import { Card } from "../../tailwind/card";
import { Button } from "../../tailwind/button";
import { AlertTriangle, CheckCircle2, ChevronRight, ExternalLink } from "lucide-react";

export const PolicyViolations = () => {
  const violations = [];

  return (
    <Card className="border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <div className="p-6 border-b border-gray-100 dark:border-slate-800 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-5 w-5 text-gray-500 dark:text-gray-400" />
          <h3 className="font-semibold text-gray-900 dark:text-white">Policy Compliance</h3>
        </div>
        <Button variant="ghost" size="sm" className="text-blue-600 dark:text-blue-400 gap-1 text-xs">
          View Commerce Policy <ExternalLink className="h-3 w-3" />
        </Button>
      </div>

      <div className="p-6">
        {violations.length === 0 ? (
          <div className="flex flex-col items-center justify-center text-center py-8">
            <div className="h-12 w-12 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-3">
              <CheckCircle2 className="h-6 w-6 text-green-600 dark:text-green-400" />
            </div>
            <h4 className="font-medium text-gray-900 dark:text-white">No Policy Violations</h4>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 max-w-sm">
              Your account is in good standing. You're following all WhatsApp Business policies.
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {/* Violation items would go here */}
          </div>
        )}
      </div>

      <div className="bg-gray-50 dark:bg-slate-800/50 p-4 border-t border-gray-100 dark:border-slate-800 rounded-b-lg">
        <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-2">Helpful Resources</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {["WhatsApp Business Policy", "Commerce Policy", "Enforcement Process"].map((item) => (
            <div key={item} className="flex items-center justify-between p-2 rounded hover:bg-white dark:hover:bg-slate-800 cursor-pointer group transition-colors">
              <span className="text-sm text-gray-600 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-400">{item}</span>
              <ChevronRight className="h-4 w-4 text-gray-300 dark:text-gray-600 group-hover:text-blue-500" />
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};